// import React, { useState, useEffect, useCallback } from "react";
// import {
//   Modal, Form, Input, InputNumber, Select, Tabs, Row, Col, 
//   Upload, Button, Switch, Divider, Space, Tag, Image, Spin,
//   message, Card, Typography, Alert, Tooltip
// } from "antd";
// import {
//   EditOutlined, SaveOutlined, PictureOutlined, BookOutlined,
//   DollarOutlined, FileTextOutlined, SettingOutlined, TagOutlined,
//   UploadOutlined, InfoCircleOutlined, ClockCircleOutlined,
//   CheckCircleOutlined, EyeOutlined, UserOutlined,
//   AppstoreOutlined, FileProtectOutlined
// } from "@ant-design/icons";
// import courseService from "../../services/course.service";

// const { Option } = Select;
// const { TextArea } = Input;
// const { TabPane } = Tabs;
// const { Title, Text } = Typography;

// // ─── Styles constants ───────────────────────────────────────
// const MODAL_STYLES = {
//   modalBody: {
//     padding: 0,
//     maxHeight: "75vh",
//     overflowY: "auto",
//   },
//   tabContent: {
//     padding: "24px",
//   },
//   sectionCard: {
//     marginBottom: 16,
//     borderRadius: 12,
//     border: "1px solid #f0f0f0",
//     boxShadow: "0 1px 4px rgba(0,0,0,0.04)",
//   },
//   sectionTitle: {
//     fontSize: 15,
//     fontWeight: 600,
//     color: "#1a1a2e",
//     marginBottom: 16,
//     display: "flex",
//     alignItems: "center",
//     gap: 8,
//   },
//   imagePreview: {
//     width: "100%",
//     maxHeight: 200,
//     objectFit: "cover",
//     borderRadius: 10,
//     border: "2px solid #f0f0f0",
//   },
//   richTextArea: {
//     minHeight: 160,
//     fontFamily: "'Segoe UI', sans-serif",
//     fontSize: 14,
//     lineHeight: 1.7,
//     borderRadius: 8,
//   },
//   footerBtn: {
//     height: 42,
//     borderRadius: 8,
//     fontWeight: 600,
//     fontSize: 14,
//     minWidth: 130,
//   },
// };

// // ─── Component ──────────────────────────────────────────────
// const CourseEditModal = ({ visible, courseId, onClose, onSuccess }) => {
//   const [form] = Form.useForm();
//   const [loading, setLoading] = useState(false);
//   const [saving, setSaving] = useState(false);
//   const [activeTab, setActiveTab] = useState("general");
//   const [categories, setCategories] = useState([]);
//   const [subcategories, setSubcategories] = useState([]);
//   const [imagePreview, setImagePreview] = useState(null);
//   const [newImageFile, setNewImageFile] = useState(null);
//   const [courseData, setCourseData] = useState(null);

//   // ─── Load course data ─────────────────────────────────────
//   const loadCourseData = useCallback(async () => {
//     if (!courseId) return;
//     setLoading(true);
//     try {
//       const data = await courseService.getCourseDetails(courseId);
//       setCourseData(data);
//       setImagePreview(data.image);

//       form.setFieldsValue({
//         title: data.title,
//         lessons: data.lessons,
//         duration: data.duration,
//         access_time: data.access_time,
//         latest_price: data.latest_price,
//         before_price: data.before_price,
//         short_desc: data.short_desc,
//         overview: data.overview,
//         requirements: data.requirements,
//         what_you_will_learn: data.what_you_will_learn,
//         who_is_this_course_for: data.who_is_this_course_for,
//         categoryId: data.category?.id || data.categoryId,
//         subcategoryId: data.subcategory?.id || data.subcategoryId,
//         entrainements_des_connaissances: data.entrainements_des_connaissances,
//         evaluation_des_connaissances: data.evaluation_des_connaissances,
//         controle_des_connaissances: data.controle_des_connaissances,
//       });

//       // Load subcategories for selected category
//       const catId = data.category?.id || data.categoryId;
//       if (catId) {
//         loadSubcategories(catId);
//       }
//     } catch (error) {
//       console.error("Erreur chargement cours:", error);
//       message.error("Impossible de charger les données du cours");
//     } finally {
//       setLoading(false);
//     }
//   }, [courseId, form]);

//   // ─── Load categories ──────────────────────────────────────
//   const loadCategories = async () => {
//     try {
//       const data = await courseService.getCategories();
//       setCategories(data);
//     } catch (error) {
//       console.error("Erreur chargement catégories:", error);
//     }
//   };

//   const loadSubcategories = async (categoryId) => {
//     try {
//       const data = await courseService.getSubcategories(categoryId);
//       setSubcategories(data);
//     } catch (error) {
//       console.error("Erreur chargement sous-catégories:", error);
//       setSubcategories([]);
//     }
//   };

//   useEffect(() => {
//     if (visible && courseId) {
//       setActiveTab("general");
//       setNewImageFile(null);
//       loadCourseData();
//       loadCategories();
//     }
//   }, [visible, courseId, loadCourseData]);

//   // ─── Handle category change ────────────────────────────────
//   const handleCategoryChange = (value) => {
//     form.setFieldValue("subcategoryId", undefined);
//     setSubcategories([]);
//     if (value) {
//       loadSubcategories(value);
//     }
//   };

//   // ─── Handle image change ──────────────────────────────────
//   const handleImageChange = (info) => {
//     const file = info.file?.originFileObj || info.file;
//     if (file) {
//       setNewImageFile(file);
//       const reader = new FileReader();
//       reader.onload = (e) => setImagePreview(e.target.result);
//       reader.readAsDataURL(file);
//     }
//   };

//   // ─── Handle save ──────────────────────────────────────────
//   const handleSave = async () => {
//     try {
//       const values = await form.validateFields();
//       setSaving(true);

//       // Build course data object
//       const updatedCourse = {
//         title: values.title,
//         lessons: values.lessons,
//         duration: values.duration,
//         access_time: values.access_time,
//         latest_price: values.latest_price,
//         before_price: values.before_price,
//         short_desc: values.short_desc,
//         overview: values.overview || "",
//         requirements: values.requirements || "",
//         what_you_will_learn: values.what_you_will_learn || "",
//         who_is_this_course_for: values.who_is_this_course_for || "",
//         entrainements_des_connaissances: values.entrainements_des_connaissances || 0,
//         evaluation_des_connaissances: values.evaluation_des_connaissances || 0,
//         controle_des_connaissances: values.controle_des_connaissances || 0,
//         category: values.categoryId ? { id: values.categoryId } : null,
//         subcategory: values.subcategoryId ? { id: values.subcategoryId } : null,
//         // Preserve existing image if no new file
//         imageUrl: courseData?.image,
//       };

//       await courseService.updateCourse(courseId, updatedCourse, newImageFile || null);

//       message.success("Cours mis à jour avec succès !");
//       onSuccess?.();
//       onClose();
//     } catch (error) {
//       if (error?.errorFields) {
//         // Validation error — switch to the tab that has the first error
//         const firstErrorField = error.errorFields[0]?.name?.[0];
//         if (firstErrorField) {
//           const tabMap = {
//             title: "general", lessons: "general", duration: "general",
//             access_time: "general", categoryId: "general", subcategoryId: "general",
//             latest_price: "pricing", before_price: "pricing",
//             short_desc: "content", overview: "content", requirements: "content",
//             what_you_will_learn: "content", who_is_this_course_for: "content",
//           };
//           const targetTab = tabMap[firstErrorField] || "general";
//           setActiveTab(targetTab);
//         }
//         message.warning("Veuillez corriger les champs obligatoires");
//       } else {
//         console.error("Erreur sauvegarde:", error);
//         message.error("Erreur lors de la mise à jour du cours");
//       }
//     } finally {
//       setSaving(false);
//     }
//   };

//   // ─── Tab: General Info ────────────────────────────────────
//   const renderGeneralTab = () => (
//     <div style={MODAL_STYLES.tabContent}>
//       {/* Image + Title row */}
//       <Row gutter={24}>
//         <Col xs={24} md={8}>
//           <Card
//             size="small"
//             style={{
//               ...MODAL_STYLES.sectionCard,
//               textAlign: "center",
//               padding: 12,
//             }}
//           >
//             <div style={MODAL_STYLES.sectionTitle}>
//               <PictureOutlined style={{ color: "#1890ff" }} />
//               Image du cours
//             </div>

//             {imagePreview ? (
//               <Image
//                 src={imagePreview}
//                 alt="Aperçu"
//                 style={MODAL_STYLES.imagePreview}
//                 fallback="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mN8/+F/PQAJpAN42sCzUAAAAABJRU5ErkJggg=="
//               />
//             ) : (
//               <div
//                 style={{
//                   height: 180,
//                   background: "#fafafa",
//                   borderRadius: 10,
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "center",
//                   border: "2px dashed #d9d9d9",
//                 }}
//               >
//                 <PictureOutlined style={{ fontSize: 40, color: "#bbb" }} />
//               </div>
//             )}

//             <Upload
//               showUploadList={false}
//               beforeUpload={() => false}
//               onChange={handleImageChange}
//               accept="image/*"
//               maxCount={1}
//             >
//               <Button
//                 icon={<UploadOutlined />}
//                 style={{ marginTop: 12, borderRadius: 8 }}
//                 block
//               >
//                 Changer l'image
//               </Button>
//             </Upload>

//             {newImageFile && (
//               <Tag
//                 color="blue"
//                 style={{ marginTop: 8, borderRadius: 6 }}
//                 closable
//                 onClose={() => {
//                   setNewImageFile(null);
//                   setImagePreview(courseData?.image);
//                 }}
//               >
//                 {newImageFile.name}
//               </Tag>
//             )}
//           </Card>
//         </Col>

//         <Col xs={24} md={16}>
//           <Card size="small" style={MODAL_STYLES.sectionCard}>
//             <div style={MODAL_STYLES.sectionTitle}>
//               <BookOutlined style={{ color: "#722ed1" }} />
//               Informations de base
//             </div>

//             <Form.Item
//               name="title"
//               label="Titre du cours"
//               rules={[{ required: true, message: "Le titre est obligatoire" }]}
//             >
//               <Input
//                 placeholder="Ex: Introduction à React.js"
//                 size="large"
//                 style={{ borderRadius: 8 }}
//               />
//             </Form.Item>

//             <Row gutter={16}>
//               <Col xs={12} md={8}>
//                 <Form.Item
//                   name="lessons"
//                   label="Nombre de leçons"
//                   rules={[{ required: true, message: "Obligatoire" }]}
//                 >
//                   <InputNumber
//                     min={1}
//                     style={{ width: "100%", borderRadius: 8 }}
//                     placeholder="Ex: 12"
//                   />
//                 </Form.Item>
//               </Col>
//               <Col xs={12} md={8}>
//                 <Form.Item
//                   name="duration"
//                   label="Durée totale"
//                   rules={[{ required: true, message: "Obligatoire" }]}
//                 >
//                   <Input
//                     placeholder="Ex: 6 heures"
//                     style={{ borderRadius: 8 }}
//                   />
//                 </Form.Item>
//               </Col>
//               <Col xs={24} md={8}>
//                 <Form.Item
//                   name="access_time"
//                   label="Durée d'accès"
//                   rules={[{ required: true, message: "Obligatoire" }]}
//                 >
//                   <Select
//                     placeholder="Sélectionner"
//                     style={{ borderRadius: 8 }}
//                   >
//                     <Option value="À vie">À vie</Option>
//                     <Option value="3 mois">3 mois</Option>
//                     <Option value="6 mois">6 mois</Option>
//                     <Option value="1 an">1 an</Option>
//                     <Option value="2 Semaines">2 Semaines</Option>
//                     <Option value="4 semaines">4 semaines</Option>
//                   </Select>
//                 </Form.Item>
//               </Col>
//             </Row>
//           </Card>

//           {/* Category section */}
//           <Card size="small" style={MODAL_STYLES.sectionCard}>
//             <div style={MODAL_STYLES.sectionTitle}>
//               <AppstoreOutlined style={{ color: "#fa8c16" }} />
//               Classification
//             </div>
//             <Row gutter={16}>
//               <Col xs={24} md={12}>
//                 <Form.Item
//                   name="categoryId"
//                   label="Catégorie"
//                   rules={[
//                     { required: true, message: "La catégorie est obligatoire" },
//                   ]}
//                 >
//                   <Select
//                     placeholder="Choisir une catégorie"
//                     onChange={handleCategoryChange}
//                     showSearch
//                     optionFilterProp="children"
//                     style={{ borderRadius: 8 }}
//                   >
//                     {categories.map((cat) => (
//                       <Option key={cat.id} value={cat.id}>
//                         {cat.libelle}
//                       </Option>
//                     ))}
//                   </Select>
//                 </Form.Item>
//               </Col>
//               <Col xs={24} md={12}>
//                 <Form.Item name="subcategoryId" label="Sous-catégorie">
//                   <Select
//                     placeholder={
//                       subcategories.length
//                         ? "Choisir une sous-catégorie"
//                         : "Sélectionnez d'abord une catégorie"
//                     }
//                     disabled={!subcategories.length}
//                     allowClear
//                     showSearch
//                     optionFilterProp="children"
//                     style={{ borderRadius: 8 }}
//                   >
//                     {subcategories.map((sub) => (
//                       <Option key={sub.id} value={sub.id}>
//                         {sub.libelle}
//                       </Option>
//                     ))}
//                   </Select>
//                 </Form.Item>
//               </Col>
//             </Row>
//           </Card>
//         </Col>
//       </Row>
//     </div>
//   );

//   // ─── Tab: Pricing ─────────────────────────────────────────
//   const renderPricingTab = () => (
//     <div style={MODAL_STYLES.tabContent}>
//       <Card size="small" style={MODAL_STYLES.sectionCard}>
//         <div style={MODAL_STYLES.sectionTitle}>
//           <DollarOutlined style={{ color: "#52c41a" }} />
//           Tarification
//         </div>

//         <Alert
//           message="Conseil"
//           description="Le prix actuel est affiché aux utilisateurs. Le prix régulier sert de prix barré pour montrer une réduction."
//           type="info"
//           showIcon
//           icon={<InfoCircleOutlined />}
//           style={{ marginBottom: 20, borderRadius: 8 }}
//         />

//         <Row gutter={24}>
//           <Col xs={24} md={12}>
//             <Card
//               bordered
//               style={{
//                 borderRadius: 12,
//                 borderColor: "#52c41a",
//                 borderWidth: 2,
//               }}
//             >
//               <div
//                 style={{
//                   textAlign: "center",
//                   marginBottom: 12,
//                 }}
//               >
//                 <Tag
//                   color="success"
//                   style={{
//                     fontSize: 14,
//                     padding: "4px 16px",
//                     borderRadius: 20,
//                   }}
//                 >
//                   Prix actuel
//                 </Tag>
//               </div>
//               <Form.Item
//                 name="latest_price"
//                 rules={[{ required: true, message: "Le prix actuel est requis" }]}
//                 style={{ marginBottom: 0 }}
//               >
//                 <InputNumber
//                   min={0}
//                   step={0.01}
//                   prefix="$"
//                   size="large"
//                   style={{
//                     width: "100%",
//                     borderRadius: 8,
//                     fontSize: 20,
//                     fontWeight: "bold",
//                   }}
//                   placeholder="0.00"
//                 />
//               </Form.Item>
//             </Card>
//           </Col>

//           <Col xs={24} md={12}>
//             <Card
//               bordered
//               style={{
//                 borderRadius: 12,
//                 borderColor: "#d9d9d9",
//               }}
//             >
//               <div
//                 style={{
//                   textAlign: "center",
//                   marginBottom: 12,
//                 }}
//               >
//                 <Tag
//                   color="default"
//                   style={{
//                     fontSize: 14,
//                     padding: "4px 16px",
//                     borderRadius: 20,
//                   }}
//                 >
//                   Prix régulier (barré)
//                 </Tag>
//               </div>
//               <Form.Item
//                 name="before_price"
//                 rules={[
//                   { required: true, message: "Le prix régulier est requis" },
//                 ]}
//                 style={{ marginBottom: 0 }}
//               >
//                 <InputNumber
//                   min={0}
//                   step={0.01}
//                   prefix="$"
//                   size="large"
//                   style={{
//                     width: "100%",
//                     borderRadius: 8,
//                     fontSize: 20,
//                     color: "#999",
//                     textDecoration: "line-through",
//                   }}
//                   placeholder="0.00"
//                 />
//               </Form.Item>
//             </Card>
//           </Col>
//         </Row>

//         {/* Price preview */}
//         <div
//           style={{
//             marginTop: 20,
//             padding: "16px 24px",
//             background: "#fafafa",
//             borderRadius: 10,
//             textAlign: "center",
//           }}
//         >
//           <Text type="secondary" style={{ fontSize: 13 }}>
//             Aperçu affiché aux étudiants :
//           </Text>
//           <div style={{ marginTop: 8 }}>
//             <span
//               style={{
//                 fontSize: 28,
//                 fontWeight: "bold",
//                 color: "#52c41a",
//                 marginRight: 12,
//               }}
//             >
//               ${form.getFieldValue("latest_price")?.toFixed(2) || "0.00"}
//             </span>
//             {form.getFieldValue("before_price") >
//               form.getFieldValue("latest_price") && (
//               <span
//                 style={{
//                   fontSize: 18,
//                   color: "#999",
//                   textDecoration: "line-through",
//                 }}
//               >
//                 ${form.getFieldValue("before_price")?.toFixed(2) || "0.00"}
//               </span>
//             )}
//           </div>
//         </div>
//       </Card>
//     </div>
//   );

//   // ─── Tab: Content ─────────────────────────────────────────
//   const renderContentTab = () => (
//     <div style={MODAL_STYLES.tabContent}>
//       {/* Short description */}
//       <Card size="small" style={MODAL_STYLES.sectionCard}>
//         <div style={MODAL_STYLES.sectionTitle}>
//           <FileTextOutlined style={{ color: "#1890ff" }} />
//           Description courte
//           <Tooltip title="Cette description apparaît dans les cartes de cours et les résultats de recherche">
//             <InfoCircleOutlined
//               style={{ color: "#bbb", fontSize: 14, cursor: "pointer" }}
//             />
//           </Tooltip>
//         </div>
//         <Form.Item
//           name="short_desc"
//           rules={[
//             { required: true, message: "La description courte est obligatoire" },
//           ]}
//         >
//           <TextArea
//             rows={3}
//             maxLength={500}
//             showCount
//             placeholder="Une brève description accrocheuse du cours..."
//             style={{ borderRadius: 8, fontSize: 14 }}
//           />
//         </Form.Item>
//       </Card>

//       {/* Overview */}
//       <Card size="small" style={MODAL_STYLES.sectionCard}>
//         <div style={MODAL_STYLES.sectionTitle}>
//           <EyeOutlined style={{ color: "#13c2c2" }} />
//           Aperçu détaillé
//           <Tag
//             color="blue"
//             style={{ marginLeft: "auto", borderRadius: 6, fontSize: 11 }}
//           >
//             HTML supporté
//           </Tag>
//         </div>
//         <Form.Item name="overview">
//           <TextArea
//             rows={6}
//             placeholder="Description détaillée du cours (HTML supporté)..."
//             style={MODAL_STYLES.richTextArea}
//           />
//         </Form.Item>
//       </Card>

//       {/* Requirements */}
//       <Card size="small" style={MODAL_STYLES.sectionCard}>
//         <div style={MODAL_STYLES.sectionTitle}>
//           <FileProtectOutlined style={{ color: "#faad14" }} />
//           Prérequis
//           <Tag
//             color="blue"
//             style={{ marginLeft: "auto", borderRadius: 6, fontSize: 11 }}
//           >
//             HTML supporté
//           </Tag>
//         </div>
//         <Form.Item name="requirements">
//           <TextArea
//             rows={4}
//             placeholder="Prérequis pour suivre ce cours (HTML supporté)..."
//             style={MODAL_STYLES.richTextArea}
//           />
//         </Form.Item>
//       </Card>

//       {/* What you will learn */}
//       <Card size="small" style={MODAL_STYLES.sectionCard}>
//         <div style={MODAL_STYLES.sectionTitle}>
//           <CheckCircleOutlined style={{ color: "#52c41a" }} />
//           Ce que vous allez apprendre
//           <Tag
//             color="blue"
//             style={{ marginLeft: "auto", borderRadius: 6, fontSize: 11 }}
//           >
//             HTML supporté
//           </Tag>
//         </div>
//         <Form.Item name="what_you_will_learn">
//           <TextArea
//             rows={5}
//             placeholder="Liste des compétences acquises (HTML supporté)..."
//             style={MODAL_STYLES.richTextArea}
//           />
//         </Form.Item>
//       </Card>

//       {/* Who is this course for */}
//       <Card size="small" style={MODAL_STYLES.sectionCard}>
//         <div style={MODAL_STYLES.sectionTitle}>
//           <UserOutlined style={{ color: "#eb2f96" }} />
//           Public cible
//           <Tag
//             color="blue"
//             style={{ marginLeft: "auto", borderRadius: 6, fontSize: 11 }}
//           >
//             HTML supporté
//           </Tag>
//         </div>
//         <Form.Item name="who_is_this_course_for">
//           <TextArea
//             rows={4}
//             placeholder="À qui s'adresse ce cours (HTML supporté)..."
//             style={MODAL_STYLES.richTextArea}
//           />
//         </Form.Item>
//       </Card>
//     </div>
//   );

//   // ─── Tab: Settings ────────────────────────────────────────
//   const renderSettingsTab = () => (
//     <div style={MODAL_STYLES.tabContent}>
//       <Card size="small" style={MODAL_STYLES.sectionCard}>
//         <div style={MODAL_STYLES.sectionTitle}>
//           <SettingOutlined style={{ color: "#722ed1" }} />
//           Paramètres des connaissances
//         </div>

//         <Alert
//           message="Configuration des modules"
//           description="Ces paramètres contrôlent l'activation des différents modules d'évaluation pour ce cours. 0 = désactivé."
//           type="info"
//           showIcon
//           style={{ marginBottom: 20, borderRadius: 8 }}
//         />

//         <Row gutter={24}>
//           <Col xs={24} md={8}>
//             <Card
//               bordered
//               style={{
//                 borderRadius: 12,
//                 textAlign: "center",
//                 borderColor: "#1890ff",
//               }}
//             >
//               <div
//                 style={{
//                   fontSize: 30,
//                   marginBottom: 8,
//                 }}
//               >
//                 📝
//               </div>
//               <Text strong style={{ display: "block", marginBottom: 8 }}>
//                 Contrôle des connaissances
//               </Text>
//               <Form.Item
//                 name="controle_des_connaissances"
//                 style={{ marginBottom: 0 }}
//               >
//                 <InputNumber
//                   min={0}
//                   style={{ width: "100%", borderRadius: 8 }}
//                   size="large"
//                 />
//               </Form.Item>
//             </Card>
//           </Col>

//           <Col xs={24} md={8}>
//             <Card
//               bordered
//               style={{
//                 borderRadius: 12,
//                 textAlign: "center",
//                 borderColor: "#52c41a",
//               }}
//             >
//               <div
//                 style={{
//                   fontSize: 30,
//                   marginBottom: 8,
//                 }}
//               >
//                 🎯
//               </div>
//               <Text strong style={{ display: "block", marginBottom: 8 }}>
//                 Évaluation des connaissances
//               </Text>
//               <Form.Item
//                 name="evaluation_des_connaissances"
//                 style={{ marginBottom: 0 }}
//               >
//                 <InputNumber
//                   min={0}
//                   style={{ width: "100%", borderRadius: 8 }}
//                   size="large"
//                 />
//               </Form.Item>
//             </Card>
//           </Col>

//           <Col xs={24} md={8}>
//             <Card
//               bordered
//               style={{
//                 borderRadius: 12,
//                 textAlign: "center",
//                 borderColor: "#faad14",
//               }}
//             >
//               <div
//                 style={{
//                   fontSize: 30,
//                   marginBottom: 8,
//                 }}
//               >
//                 🏋️
//               </div>
//               <Text strong style={{ display: "block", marginBottom: 8 }}>
//                 Entraînements
//               </Text>
//               <Form.Item
//                 name="entrainements_des_connaissances"
//                 style={{ marginBottom: 0 }}
//               >
//                 <InputNumber
//                   min={0}
//                   style={{ width: "100%", borderRadius: 8 }}
//                   size="large"
//                 />
//               </Form.Item>
//             </Card>
//           </Col>
//         </Row>
//       </Card>

//       {/* Course metadata (read-only info) */}
//       {courseData && (
//         <Card size="small" style={MODAL_STYLES.sectionCard}>
//           <div style={MODAL_STYLES.sectionTitle}>
//             <InfoCircleOutlined style={{ color: "#8c8c8c" }} />
//             Métadonnées
//           </div>
//           <Row gutter={16}>
//             <Col span={8}>
//               <Text type="secondary">ID du cours</Text>
//               <div>
//                 <Tag color="blue" style={{ borderRadius: 6, marginTop: 4 }}>
//                   #{courseData.id}
//                 </Tag>
//               </div>
//             </Col>
//             <Col span={8}>
//               <Text type="secondary">Créé par (ID)</Text>
//               <div>
//                 <Tag style={{ borderRadius: 6, marginTop: 4 }}>
//                   {courseData.createdBy}
//                 </Tag>
//               </div>
//             </Col>
//             <Col span={8}>
//               <Text type="secondary">Statut</Text>
//               <div style={{ marginTop: 4 }}>
//                 <Tag
//                   color={courseData.approved ? "success" : "warning"}
//                   style={{ borderRadius: 6 }}
//                   icon={
//                     courseData.approved ? (
//                       <CheckCircleOutlined />
//                     ) : (
//                       <ClockCircleOutlined />
//                     )
//                   }
//                 >
//                   {courseData.approved ? "Approuvé" : "En attente"}
//                 </Tag>
//               </div>
//             </Col>
//           </Row>
//         </Card>
//       )}
//     </div>
//   );

//   // ─── Tab config ───────────────────────────────────────────
//   const tabItems = [
//     {
//       key: "general",
//       label: (
//         <span>
//           <BookOutlined style={{ marginRight: 6 }} />
//           Général
//         </span>
//       ),
//       children: renderGeneralTab(),
//     },
//     {
//       key: "pricing",
//       label: (
//         <span>
//           <DollarOutlined style={{ marginRight: 6 }} />
//           Tarification
//         </span>
//       ),
//       children: renderPricingTab(),
//     },
//     {
//       key: "content",
//       label: (
//         <span>
//           <FileTextOutlined style={{ marginRight: 6 }} />
//           Contenu
//         </span>
//       ),
//       children: renderContentTab(),
//     },
//     {
//       key: "settings",
//       label: (
//         <span>
//           <SettingOutlined style={{ marginRight: 6 }} />
//           Paramètres
//         </span>
//       ),
//       children: renderSettingsTab(),
//     },
//   ];

//   // ─── Render ───────────────────────────────────────────────
//   return (
//     <Modal
//       open={visible}
//       title={
//         <div
//           style={{
//             display: "flex",
//             alignItems: "center",
//             gap: 10,
//             padding: "4px 0",
//           }}
//         >
//           <div
//             style={{
//               width: 36,
//               height: 36,
//               borderRadius: 10,
//               background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "center",
//             }}
//           >
//             <EditOutlined style={{ color: "#fff", fontSize: 18 }} />
//           </div>
//           <div>
//             <div
//               style={{
//                 fontSize: 16,
//                 fontWeight: 700,
//                 color: "#1a1a2e",
//                 lineHeight: 1.3,
//               }}
//             >
//               Modifier le cours
//             </div>
//             <div style={{ fontSize: 12, color: "#8c8c8c", fontWeight: 400 }}>
//               {courseData?.title
//                 ? `#${courseData.id} — ${courseData.title}`
//                 : "Chargement..."}
//             </div>
//           </div>
//         </div>
//       }
//       width="85%"
//       style={{ top: 30, maxWidth: 1100 }}
//       bodyStyle={MODAL_STYLES.modalBody}
//       destroyOnClose
//       maskClosable={false}
//       onCancel={onClose}
//       footer={
//         <div
//           style={{
//             display: "flex",
//             justifyContent: "space-between",
//             alignItems: "center",
//             padding: "8px 0",
//           }}
//         >
//           <Text type="secondary" style={{ fontSize: 12 }}>
//             {newImageFile
//               ? `📷 Nouvelle image sélectionnée: ${newImageFile.name}`
//               : "Aucune modification d'image"}
//           </Text>
//           <Space>
//             <Button
//               onClick={onClose}
//               style={{
//                 ...MODAL_STYLES.footerBtn,
//                 background: "#f5f5f5",
//               }}
//             >
//               Annuler
//             </Button>
//             <Button
//               type="primary"
//               onClick={handleSave}
//               loading={saving}
//               icon={<SaveOutlined />}
//               style={{
//                 ...MODAL_STYLES.footerBtn,
//                 background:
//                   "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
//                 border: "none",
//               }}
//             >
//               {saving ? "Enregistrement..." : "Enregistrer"}
//             </Button>
//           </Space>
//         </div>
//       }
//     >
//       <Spin spinning={loading} tip="Chargement des données du cours...">
//         <Form
//           form={form}
//           layout="vertical"
//           requiredMark="optional"
//           size="middle"
//         >
//           <Tabs
//             activeKey={activeTab}
//             onChange={setActiveTab}
//             type="card"
//             style={{ padding: "0 24px" }}
//             items={tabItems}
//           />
//         </Form>
//       </Spin>
//     </Modal>
//   );
// };

// export default CourseEditModal;


import React, { useState, useEffect, useCallback } from "react";
import {
  Modal, Form, Input, InputNumber, Select, Tabs, Row, Col, 
  Upload, Button, Switch, Divider, Space, Tag, Image, Spin,
  message, Card, Typography, Alert, Tooltip
} from "antd";
import {
  EditOutlined, SaveOutlined, PictureOutlined, BookOutlined,
  DollarOutlined, FileTextOutlined, SettingOutlined, TagOutlined,
  UploadOutlined, InfoCircleOutlined, ClockCircleOutlined,
  CheckCircleOutlined, EyeOutlined, UserOutlined,
  AppstoreOutlined, FileProtectOutlined
} from "@ant-design/icons";
import courseService from "../../services/course.service";

const { Option } = Select;
const { TextArea } = Input;
const { TabPane } = Tabs;
const { Title, Text } = Typography;

// ─── Styles constants ───────────────────────────────────────
const MODAL_STYLES = {
  modalBody: {
    padding: 0,
    maxHeight: "75vh",
    overflowY: "auto",
  },
  tabContent: {
    padding: "24px",
  },
  sectionCard: {
    marginBottom: 16,
    borderRadius: 12,
    border: "1px solid #f0f0f0",
    boxShadow: "0 1px 4px rgba(0,0,0,0.04)",
  },
  sectionTitle: {
    fontSize: 15,
    fontWeight: 600,
    color: "#1a1a2e",
    marginBottom: 16,
    display: "flex",
    alignItems: "center",
    gap: 8,
  },
  imagePreview: {
    width: "100%",
    maxHeight: 200,
    objectFit: "cover",
    borderRadius: 10,
    border: "2px solid #f0f0f0",
  },
  richTextArea: {
    minHeight: 160,
    fontFamily: "'Segoe UI', sans-serif",
    fontSize: 14,
    lineHeight: 1.7,
    borderRadius: 8,
  },
  footerBtn: {
    height: 42,
    borderRadius: 8,
    fontWeight: 600,
    fontSize: 14,
    minWidth: 130,
  },
};

// ─── Component ──────────────────────────────────────────────
const CourseEditModal = ({ visible, courseId, onClose, onSuccess }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [activeTab, setActiveTab] = useState("general");
  const [categories, setCategories] = useState([]);
  const [subcategories, setSubcategories] = useState([]);
  const [imagePreview, setImagePreview] = useState(null);
  const [newImageFile, setNewImageFile] = useState(null);
  const [courseData, setCourseData] = useState(null);

  // ─── Load course data ─────────────────────────────────────
  const loadCourseData = useCallback(async () => {
    if (!courseId) return;
    setLoading(true);
    try {
      const data = await courseService.getCourseDetails(courseId);
      setCourseData(data);
      setImagePreview(data.image);

      form.setFieldsValue({
        title: data.title,
        lessons: data.lessons,
        duration: data.duration,
        access_time: data.access_time,
        latest_price: data.latest_price,
        before_price: data.before_price,
        short_desc: data.short_desc,
        overview: data.overview,
        requirements: data.requirements,
        what_you_will_learn: data.what_you_will_learn,
        who_is_this_course_for: data.who_is_this_course_for,
        categoryId: data.category?.id || data.categoryId,
        subcategoryId: data.subcategory?.id || data.subcategoryId,
        entrainements_des_connaissances: data.entrainements_des_connaissances,
        evaluation_des_connaissances: data.evaluation_des_connaissances,
        controle_des_connaissances: data.controle_des_connaissances,
      });

      // Load subcategories for selected category
      const catId = data.category?.id || data.categoryId;
      if (catId) {
        loadSubcategories(catId);
      }
    } catch (error) {
      console.error("Erreur chargement cours:", error);
      message.error("Impossible de charger les données du cours");
    } finally {
      setLoading(false);
    }
  }, [courseId, form]);

  // ─── Load categories ──────────────────────────────────────
  const loadCategories = async () => {
    try {
      const data = await courseService.getCategories();
      setCategories(data);
    } catch (error) {
      console.error("Erreur chargement catégories:", error);
    }
  };

  const loadSubcategories = async (categoryId) => {
    try {
      const data = await courseService.getSubcategories(categoryId);
      setSubcategories(data);
    } catch (error) {
      console.error("Erreur chargement sous-catégories:", error);
      setSubcategories([]);
    }
  };

  useEffect(() => {
    if (visible && courseId) {
      setActiveTab("general");
      setNewImageFile(null);
      loadCourseData();
      loadCategories();
    }
  }, [visible, courseId, loadCourseData]);

  // ─── Handle category change ────────────────────────────────
  const handleCategoryChange = (value) => {
    form.setFieldValue("subcategoryId", undefined);
    setSubcategories([]);
    if (value) {
      loadSubcategories(value);
    }
  };

  // ─── Handle image change ──────────────────────────────────
  const handleImageChange = (info) => {
    const file = info.file?.originFileObj || info.file;
    if (file) {
      setNewImageFile(file);
      const reader = new FileReader();
      reader.onload = (e) => setImagePreview(e.target.result);
      reader.readAsDataURL(file);
    }
  };

  // ✅ Helper : retourne la valeur du form si elle est définie,
  //    sinon retombe sur la valeur existante du cours (fallback).
  //    Évite d'écraser un champ par "vide" si l'onglet n'a pas été visité.
  const pick = (formValue, fallback) =>
    formValue === undefined || formValue === null ? fallback : formValue;

  // ─── Handle save ──────────────────────────────────────────
  const handleSave = async () => {
    try {
      // ✅ Empêcher la sauvegarde tant que les données ne sont pas chargées
      if (loading || !courseData) {
        message.warning("Veuillez attendre la fin du chargement du cours.");
        return;
      }

      const values = await form.validateFields();
      setSaving(true);

      // ✅ On PART des données déjà chargées (courseData) et on n'écrase
      //    QUE par les valeurs réellement présentes dans le formulaire.
      //    Ainsi, les champs d'un onglet non visité ne sont jamais perdus.
      const updatedCourse = {
        title: pick(values.title, courseData.title),
        lessons: pick(values.lessons, courseData.lessons),
        duration: pick(values.duration, courseData.duration),
        access_time: pick(values.access_time, courseData.access_time),
        latest_price: pick(values.latest_price, courseData.latest_price),
        before_price: pick(values.before_price, courseData.before_price),
        short_desc: pick(values.short_desc, courseData.short_desc),
        overview: pick(values.overview, courseData.overview),
        requirements: pick(values.requirements, courseData.requirements),
        what_you_will_learn: pick(values.what_you_will_learn, courseData.what_you_will_learn),
        who_is_this_course_for: pick(values.who_is_this_course_for, courseData.who_is_this_course_for),
        entrainements_des_connaissances: pick(
          values.entrainements_des_connaissances,
          courseData.entrainements_des_connaissances ?? 0
        ),
        evaluation_des_connaissances: pick(
          values.evaluation_des_connaissances,
          courseData.evaluation_des_connaissances ?? 0
        ),
        controle_des_connaissances: pick(
          values.controle_des_connaissances,
          courseData.controle_des_connaissances ?? 0
        ),
        category: values.categoryId
          ? { id: values.categoryId }
          : (courseData.category?.id ? { id: courseData.category.id } : null),
        subcategory: values.subcategoryId
          ? { id: values.subcategoryId }
          : null,
        // Préserver l'image existante si aucun nouveau fichier
        imageUrl: courseData?.image,
      };

      await courseService.updateCourse(courseId, updatedCourse, newImageFile || null);

      message.success("Cours mis à jour avec succès !");
      onSuccess?.();
      onClose();
    } catch (error) {
      if (error?.errorFields) {
        // Validation error — switch to the tab that has the first error
        const firstErrorField = error.errorFields[0]?.name?.[0];
        if (firstErrorField) {
          const tabMap = {
            title: "general", lessons: "general", duration: "general",
            access_time: "general", categoryId: "general", subcategoryId: "general",
            latest_price: "pricing", before_price: "pricing",
            short_desc: "content", overview: "content", requirements: "content",
            what_you_will_learn: "content", who_is_this_course_for: "content",
          };
          const targetTab = tabMap[firstErrorField] || "general";
          setActiveTab(targetTab);
        }
        message.warning("Veuillez corriger les champs obligatoires");
      } else {
        console.error("Erreur sauvegarde:", error);
        message.error("Erreur lors de la mise à jour du cours");
      }
    } finally {
      setSaving(false);
    }
  };

  // ─── Tab: General Info ────────────────────────────────────
  const renderGeneralTab = () => (
    <div style={MODAL_STYLES.tabContent}>
      {/* Image + Title row */}
      <Row gutter={24}>
        <Col xs={24} md={8}>
          <Card
            size="small"
            style={{
              ...MODAL_STYLES.sectionCard,
              textAlign: "center",
              padding: 12,
            }}
          >
            <div style={MODAL_STYLES.sectionTitle}>
              <PictureOutlined style={{ color: "#1890ff" }} />
              Image du cours
            </div>

            {imagePreview ? (
              <Image
                src={imagePreview}
                alt="Aperçu"
                style={MODAL_STYLES.imagePreview}
                fallback="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mN8/+F/PQAJpAN42sCzUAAAAABJRU5ErkJggg=="
              />
            ) : (
              <div
                style={{
                  height: 180,
                  background: "#fafafa",
                  borderRadius: 10,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  border: "2px dashed #d9d9d9",
                }}
              >
                <PictureOutlined style={{ fontSize: 40, color: "#bbb" }} />
              </div>
            )}

            <Upload
              showUploadList={false}
              beforeUpload={() => false}
              onChange={handleImageChange}
              accept="image/*"
              maxCount={1}
            >
              <Button
                icon={<UploadOutlined />}
                style={{ marginTop: 12, borderRadius: 8 }}
                block
              >
                Changer l'image
              </Button>
            </Upload>

            {newImageFile && (
              <Tag
                color="blue"
                style={{ marginTop: 8, borderRadius: 6 }}
                closable
                onClose={() => {
                  setNewImageFile(null);
                  setImagePreview(courseData?.image);
                }}
              >
                {newImageFile.name}
              </Tag>
            )}
          </Card>
        </Col>

        <Col xs={24} md={16}>
          <Card size="small" style={MODAL_STYLES.sectionCard}>
            <div style={MODAL_STYLES.sectionTitle}>
              <BookOutlined style={{ color: "#722ed1" }} />
              Informations de base
            </div>

            <Form.Item
              name="title"
              label="Titre du cours"
              rules={[{ required: true, message: "Le titre est obligatoire" }]}
            >
              <Input
                placeholder="Ex: Introduction à React.js"
                size="large"
                style={{ borderRadius: 8 }}
              />
            </Form.Item>

            <Row gutter={16}>
              <Col xs={12} md={8}>
                <Form.Item
                  name="lessons"
                  label="Nombre de leçons"
                  rules={[{ required: true, message: "Obligatoire" }]}
                >
                  <InputNumber
                    min={1}
                    style={{ width: "100%", borderRadius: 8 }}
                    placeholder="Ex: 12"
                  />
                </Form.Item>
              </Col>
              <Col xs={12} md={8}>
                <Form.Item
                  name="duration"
                  label="Durée totale"
                  rules={[{ required: true, message: "Obligatoire" }]}
                >
                  <Input
                    placeholder="Ex: 6 heures"
                    style={{ borderRadius: 8 }}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} md={8}>
                <Form.Item
                  name="access_time"
                  label="Durée d'accès"
                  rules={[{ required: true, message: "Obligatoire" }]}
                >
                  <Select
                    placeholder="Sélectionner"
                    style={{ borderRadius: 8 }}
                  >
                    <Option value="À vie">À vie</Option>
                    <Option value="3 mois">3 mois</Option>
                    <Option value="6 mois">6 mois</Option>
                    <Option value="1 an">1 an</Option>
                    <Option value="2 Semaines">2 Semaines</Option>
                    <Option value="4 semaines">4 semaines</Option>
                  </Select>
                </Form.Item>
              </Col>
            </Row>
          </Card>

          {/* Category section */}
          <Card size="small" style={MODAL_STYLES.sectionCard}>
            <div style={MODAL_STYLES.sectionTitle}>
              <AppstoreOutlined style={{ color: "#fa8c16" }} />
              Classification
            </div>
            <Row gutter={16}>
              <Col xs={24} md={12}>
                <Form.Item
                  name="categoryId"
                  label="Catégorie"
                  rules={[
                    { required: true, message: "La catégorie est obligatoire" },
                  ]}
                >
                  <Select
                    placeholder="Choisir une catégorie"
                    onChange={handleCategoryChange}
                    showSearch
                    optionFilterProp="children"
                    style={{ borderRadius: 8 }}
                  >
                    {categories.map((cat) => (
                      <Option key={cat.id} value={cat.id}>
                        {cat.libelle}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={24} md={12}>
                <Form.Item name="subcategoryId" label="Sous-catégorie">
                  <Select
                    placeholder={
                      subcategories.length
                        ? "Choisir une sous-catégorie"
                        : "Sélectionnez d'abord une catégorie"
                    }
                    disabled={!subcategories.length}
                    allowClear
                    showSearch
                    optionFilterProp="children"
                    style={{ borderRadius: 8 }}
                  >
                    {subcategories.map((sub) => (
                      <Option key={sub.id} value={sub.id}>
                        {sub.libelle}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
            </Row>
          </Card>
        </Col>
      </Row>
    </div>
  );

  // ─── Tab: Pricing ─────────────────────────────────────────
  const renderPricingTab = () => (
    <div style={MODAL_STYLES.tabContent}>
      <Card size="small" style={MODAL_STYLES.sectionCard}>
        <div style={MODAL_STYLES.sectionTitle}>
          <DollarOutlined style={{ color: "#52c41a" }} />
          Tarification
        </div>

        <Alert
          message="Conseil"
          description="Le prix actuel est affiché aux utilisateurs. Le prix régulier sert de prix barré pour montrer une réduction."
          type="info"
          showIcon
          icon={<InfoCircleOutlined />}
          style={{ marginBottom: 20, borderRadius: 8 }}
        />

        <Row gutter={24}>
          <Col xs={24} md={12}>
            <Card
              bordered
              style={{
                borderRadius: 12,
                borderColor: "#52c41a",
                borderWidth: 2,
              }}
            >
              <div
                style={{
                  textAlign: "center",
                  marginBottom: 12,
                }}
              >
                <Tag
                  color="success"
                  style={{
                    fontSize: 14,
                    padding: "4px 16px",
                    borderRadius: 20,
                  }}
                >
                  Prix actuel
                </Tag>
              </div>
              <Form.Item
                name="latest_price"
                rules={[{ required: true, message: "Le prix actuel est requis" }]}
                style={{ marginBottom: 0 }}
              >
                <InputNumber
                  min={0}
                  step={0.01}
                  prefix="$"
                  size="large"
                  style={{
                    width: "100%",
                    borderRadius: 8,
                    fontSize: 20,
                    fontWeight: "bold",
                  }}
                  placeholder="0.00"
                />
              </Form.Item>
            </Card>
          </Col>

          <Col xs={24} md={12}>
            <Card
              bordered
              style={{
                borderRadius: 12,
                borderColor: "#d9d9d9",
              }}
            >
              <div
                style={{
                  textAlign: "center",
                  marginBottom: 12,
                }}
              >
                <Tag
                  color="default"
                  style={{
                    fontSize: 14,
                    padding: "4px 16px",
                    borderRadius: 20,
                  }}
                >
                  Prix régulier (barré)
                </Tag>
              </div>
              <Form.Item
                name="before_price"
                rules={[
                  { required: true, message: "Le prix régulier est requis" },
                ]}
                style={{ marginBottom: 0 }}
              >
                <InputNumber
                  min={0}
                  step={0.01}
                  prefix="$"
                  size="large"
                  style={{
                    width: "100%",
                    borderRadius: 8,
                    fontSize: 20,
                    color: "#999",
                    textDecoration: "line-through",
                  }}
                  placeholder="0.00"
                />
              </Form.Item>
            </Card>
          </Col>
        </Row>

        {/* Price preview */}
        <div
          style={{
            marginTop: 20,
            padding: "16px 24px",
            background: "#fafafa",
            borderRadius: 10,
            textAlign: "center",
          }}
        >
          <Text type="secondary" style={{ fontSize: 13 }}>
            Aperçu affiché aux étudiants :
          </Text>
          <div style={{ marginTop: 8 }}>
            <span
              style={{
                fontSize: 28,
                fontWeight: "bold",
                color: "#52c41a",
                marginRight: 12,
              }}
            >
              ${form.getFieldValue("latest_price")?.toFixed(2) || "0.00"}
            </span>
            {form.getFieldValue("before_price") >
              form.getFieldValue("latest_price") && (
              <span
                style={{
                  fontSize: 18,
                  color: "#999",
                  textDecoration: "line-through",
                }}
              >
                ${form.getFieldValue("before_price")?.toFixed(2) || "0.00"}
              </span>
            )}
          </div>
        </div>
      </Card>
    </div>
  );

  // ─── Tab: Content ─────────────────────────────────────────
  const renderContentTab = () => (
    <div style={MODAL_STYLES.tabContent}>
      {/* Short description */}
      <Card size="small" style={MODAL_STYLES.sectionCard}>
        <div style={MODAL_STYLES.sectionTitle}>
          <FileTextOutlined style={{ color: "#1890ff" }} />
          Description courte
          <Tooltip title="Cette description apparaît dans les cartes de cours et les résultats de recherche">
            <InfoCircleOutlined
              style={{ color: "#bbb", fontSize: 14, cursor: "pointer" }}
            />
          </Tooltip>
        </div>
        <Form.Item
          name="short_desc"
          rules={[
            { required: true, message: "La description courte est obligatoire" },
          ]}
        >
          <TextArea
            rows={3}
            maxLength={500}
            showCount
            placeholder="Une brève description accrocheuse du cours..."
            style={{ borderRadius: 8, fontSize: 14 }}
          />
        </Form.Item>
      </Card>

      {/* Overview */}
      <Card size="small" style={MODAL_STYLES.sectionCard}>
        <div style={MODAL_STYLES.sectionTitle}>
          <EyeOutlined style={{ color: "#13c2c2" }} />
          Aperçu détaillé
          <Tag
            color="blue"
            style={{ marginLeft: "auto", borderRadius: 6, fontSize: 11 }}
          >
            HTML supporté
          </Tag>
        </div>
        <Form.Item name="overview">
          <TextArea
            rows={6}
            placeholder="Description détaillée du cours (HTML supporté)..."
            style={MODAL_STYLES.richTextArea}
          />
        </Form.Item>
      </Card>

      {/* Requirements */}
      <Card size="small" style={MODAL_STYLES.sectionCard}>
        <div style={MODAL_STYLES.sectionTitle}>
          <FileProtectOutlined style={{ color: "#faad14" }} />
          Prérequis
          <Tag
            color="blue"
            style={{ marginLeft: "auto", borderRadius: 6, fontSize: 11 }}
          >
            HTML supporté
          </Tag>
        </div>
        <Form.Item name="requirements">
          <TextArea
            rows={4}
            placeholder="Prérequis pour suivre ce cours (HTML supporté)..."
            style={MODAL_STYLES.richTextArea}
          />
        </Form.Item>
      </Card>

      {/* What you will learn */}
      <Card size="small" style={MODAL_STYLES.sectionCard}>
        <div style={MODAL_STYLES.sectionTitle}>
          <CheckCircleOutlined style={{ color: "#52c41a" }} />
          Ce que vous allez apprendre
          <Tag
            color="blue"
            style={{ marginLeft: "auto", borderRadius: 6, fontSize: 11 }}
          >
            HTML supporté
          </Tag>
        </div>
        <Form.Item name="what_you_will_learn">
          <TextArea
            rows={5}
            placeholder="Liste des compétences acquises (HTML supporté)..."
            style={MODAL_STYLES.richTextArea}
          />
        </Form.Item>
      </Card>

      {/* Who is this course for */}
      <Card size="small" style={MODAL_STYLES.sectionCard}>
        <div style={MODAL_STYLES.sectionTitle}>
          <UserOutlined style={{ color: "#eb2f96" }} />
          Public cible
          <Tag
            color="blue"
            style={{ marginLeft: "auto", borderRadius: 6, fontSize: 11 }}
          >
            HTML supporté
          </Tag>
        </div>
        <Form.Item name="who_is_this_course_for">
          <TextArea
            rows={4}
            placeholder="À qui s'adresse ce cours (HTML supporté)..."
            style={MODAL_STYLES.richTextArea}
          />
        </Form.Item>
      </Card>
    </div>
  );

  // ─── Tab: Settings ────────────────────────────────────────
  const renderSettingsTab = () => (
    <div style={MODAL_STYLES.tabContent}>
      <Card size="small" style={MODAL_STYLES.sectionCard}>
        <div style={MODAL_STYLES.sectionTitle}>
          <SettingOutlined style={{ color: "#722ed1" }} />
          Paramètres des connaissances
        </div>

        <Alert
          message="Configuration des modules"
          description="Ces paramètres contrôlent l'activation des différents modules d'évaluation pour ce cours. 0 = désactivé."
          type="info"
          showIcon
          style={{ marginBottom: 20, borderRadius: 8 }}
        />

        <Row gutter={24}>
          <Col xs={24} md={8}>
            <Card
              bordered
              style={{
                borderRadius: 12,
                textAlign: "center",
                borderColor: "#1890ff",
              }}
            >
              <div
                style={{
                  fontSize: 30,
                  marginBottom: 8,
                }}
              >
                📝
              </div>
              <Text strong style={{ display: "block", marginBottom: 8 }}>
                Contrôle des connaissances
              </Text>
              <Form.Item
                name="controle_des_connaissances"
                style={{ marginBottom: 0 }}
              >
                <InputNumber
                  min={0}
                  style={{ width: "100%", borderRadius: 8 }}
                  size="large"
                />
              </Form.Item>
            </Card>
          </Col>

          <Col xs={24} md={8}>
            <Card
              bordered
              style={{
                borderRadius: 12,
                textAlign: "center",
                borderColor: "#52c41a",
              }}
            >
              <div
                style={{
                  fontSize: 30,
                  marginBottom: 8,
                }}
              >
                🎯
              </div>
              <Text strong style={{ display: "block", marginBottom: 8 }}>
                Évaluation des connaissances
              </Text>
              <Form.Item
                name="evaluation_des_connaissances"
                style={{ marginBottom: 0 }}
              >
                <InputNumber
                  min={0}
                  style={{ width: "100%", borderRadius: 8 }}
                  size="large"
                />
              </Form.Item>
            </Card>
          </Col>

          <Col xs={24} md={8}>
            <Card
              bordered
              style={{
                borderRadius: 12,
                textAlign: "center",
                borderColor: "#faad14",
              }}
            >
              <div
                style={{
                  fontSize: 30,
                  marginBottom: 8,
                }}
              >
                🏋️
              </div>
              <Text strong style={{ display: "block", marginBottom: 8 }}>
                Entraînements
              </Text>
              <Form.Item
                name="entrainements_des_connaissances"
                style={{ marginBottom: 0 }}
              >
                <InputNumber
                  min={0}
                  style={{ width: "100%", borderRadius: 8 }}
                  size="large"
                />
              </Form.Item>
            </Card>
          </Col>
        </Row>
      </Card>

      {/* Course metadata (read-only info) */}
      {courseData && (
        <Card size="small" style={MODAL_STYLES.sectionCard}>
          <div style={MODAL_STYLES.sectionTitle}>
            <InfoCircleOutlined style={{ color: "#8c8c8c" }} />
            Métadonnées
          </div>
          <Row gutter={16}>
            <Col span={8}>
              <Text type="secondary">ID du cours</Text>
              <div>
                <Tag color="blue" style={{ borderRadius: 6, marginTop: 4 }}>
                  #{courseData.id}
                </Tag>
              </div>
            </Col>
            <Col span={8}>
              <Text type="secondary">Créé par (ID)</Text>
              <div>
                <Tag style={{ borderRadius: 6, marginTop: 4 }}>
                  {courseData.createdBy}
                </Tag>
              </div>
            </Col>
            <Col span={8}>
              <Text type="secondary">Statut</Text>
              <div style={{ marginTop: 4 }}>
                <Tag
                  color={courseData.approved ? "success" : "warning"}
                  style={{ borderRadius: 6 }}
                  icon={
                    courseData.approved ? (
                      <CheckCircleOutlined />
                    ) : (
                      <ClockCircleOutlined />
                    )
                  }
                >
                  {courseData.approved ? "Approuvé" : "En attente"}
                </Tag>
              </div>
            </Col>
          </Row>
        </Card>
      )}
    </div>
  );

  // ─── Tab config ───────────────────────────────────────────
  const tabItems = [
    {
      key: "general",
      label: (
        <span>
          <BookOutlined style={{ marginRight: 6 }} />
          Général
        </span>
      ),
      children: renderGeneralTab(),
    },
    {
      key: "pricing",
      label: (
        <span>
          <DollarOutlined style={{ marginRight: 6 }} />
          Tarification
        </span>
      ),
      children: renderPricingTab(),
    },
    {
      key: "content",
      label: (
        <span>
          <FileTextOutlined style={{ marginRight: 6 }} />
          Contenu
        </span>
      ),
      children: renderContentTab(),
    },
    {
      key: "settings",
      label: (
        <span>
          <SettingOutlined style={{ marginRight: 6 }} />
          Paramètres
        </span>
      ),
      children: renderSettingsTab(),
    },
  ];

  // ─── Render ───────────────────────────────────────────────
  return (
    <Modal
      open={visible}
      title={
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 10,
            padding: "4px 0",
          }}
        >
          <div
            style={{
              width: 36,
              height: 36,
              borderRadius: 10,
              background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <EditOutlined style={{ color: "#fff", fontSize: 18 }} />
          </div>
          <div>
            <div
              style={{
                fontSize: 16,
                fontWeight: 700,
                color: "#1a1a2e",
                lineHeight: 1.3,
              }}
            >
              Modifier le cours
            </div>
            <div style={{ fontSize: 12, color: "#8c8c8c", fontWeight: 400 }}>
              {courseData?.title
                ? `#${courseData.id} — ${courseData.title}`
                : "Chargement..."}
            </div>
          </div>
        </div>
      }
      width="85%"
      style={{ top: 30, maxWidth: 1100 }}
      bodyStyle={MODAL_STYLES.modalBody}
      destroyOnClose
      maskClosable={false}
      onCancel={onClose}
      footer={
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "8px 0",
          }}
        >
          <Text type="secondary" style={{ fontSize: 12 }}>
            {newImageFile
              ? `📷 Nouvelle image sélectionnée: ${newImageFile.name}`
              : "Aucune modification d'image"}
          </Text>
          <Space>
            <Button
              onClick={onClose}
              style={{
                ...MODAL_STYLES.footerBtn,
                background: "#f5f5f5",
              }}
            >
              Annuler
            </Button>
            <Button
              type="primary"
              onClick={handleSave}
              loading={saving}
              disabled={loading}
              icon={<SaveOutlined />}
              style={{
                ...MODAL_STYLES.footerBtn,
                background:
                  "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                border: "none",
              }}
            >
              {saving ? "Enregistrement..." : "Enregistrer"}
            </Button>
          </Space>
        </div>
      }
    >
      <Spin spinning={loading} tip="Chargement des données du cours...">
        <Form
          form={form}
          layout="vertical"
          requiredMark="optional"
          size="middle"
        >
          <Tabs
            activeKey={activeTab}
            onChange={setActiveTab}
            type="card"
            style={{ padding: "0 24px" }}
            items={tabItems}
          />
        </Form>
      </Spin>
    </Modal>
  );
};

export default CourseEditModal;